export default __webpack_public_path__ + "static/addcard-hero-e4e39f05b22409808ff120664beb37d3.webp";